import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
/*import Admin from './admin';*/
import Router from './router/router'
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux'
import configureStore from './redux/store/configureStore';

const store = configureStore();
ReactDOM.render(
    <Provider store={store}>
        <Router />
    </Provider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js